import React, {useState} from 'react'
import DeliveryWizard from '@components/DeliveryWizard'
import usePreferencesForAddressContext from '@components/DeliveryWizard/internals/hooks/usePreferencesForAddressContext.main'
import {productListInformation} from '@data/fragments/products/__generated__/productListInformation'
import classnames from '@helpers/misc/classnames'
import productRequiredModifiers from '@helpers/misc/productWithRequiredModifiers'
import useAdd from '@page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd'
import Link from 'next/link'
import {useRouter} from 'next/router'

import AddProductButton from './AddProductButton'
import Badge from './Badge'
import ProductDescriptionSection from './ProductDescriptionSection'
import ProductImage from './ProductImage'
import ProductPrice from './ProductPrice'

interface RowProductProps {
  product: productListInformation
  onClick: () => void
  menuId: string
  fastAddToCart?: boolean
  hidePrice: boolean
  reverse: boolean
  href: string
  description: string
}

function RowProductV2(props: RowProductProps) {
  const router = useRouter()
  const {preferences} = usePreferencesForAddressContext()
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false)
  const {product, reverse, onClick, menuId, fastAddToCart = false, hidePrice, href} = props
  const {isOutOfStock, availabilityAt} = product
  const add = useAdd()
  const requiredModifiers = productRequiredModifiers(product)
  const disabledProduct = isOutOfStock || !availabilityAt?.available

  const handleAddProduct = async (e: React.MouseEvent<HTMLElement>) => {
    if (disabledProduct) return null
    e.preventDefault()
    if (requiredModifiers || !fastAddToCart) {
      onClick()
      router.push(href, href, {scroll: false})
    } else {
      if (!preferences?.storeId) {
        setIsAddressModalOpen(true)
        return
      }
      await add(
        {
          ...props,
          close: () => {
            // avoid error on add to cart
          },
          menuId: menuId
        },
        {amount: 1, modifiers: [], comment: ''},
        product,
        {
          missingModifier: false
        }
      )
    }
  }
  return (
    <Link href={props.href} prefetch={false} scroll={false}>
      <a
        className={classnames(
          'relative bg-white shadow-md rounded-lg h-40 w-96 flex items-stretch shadow-[4px_0_20px_0px_rgba(0,0,0,0.08)]',
          {
            'bg-black/1': disabledProduct,
            'flex-row': !reverse,
            'flex-row-reverse': reverse
          }
        )}>
        <ProductImage product={product} disabledProduct={disabledProduct} reverse={reverse} />
        <div className="flex flex-col p-3.5 pr-3 w-56 justify-between">
          <ProductDescriptionSection product={product} />
          {!hidePrice && <ProductPrice product={product} />}
        </div>
        <Badge product={product} disabledProduct={disabledProduct} reverse={reverse} />
        <AddProductButton handleAddProduct={handleAddProduct} disabledProduct={disabledProduct} />
        {isAddressModalOpen ? (
          <DeliveryWizard.AsModal
            isOpen={isAddressModalOpen}
            onClose={() => {
              setIsAddressModalOpen(false)
            }}
            actionLocation="quick-add-product"
          />
        ) : null}
      </a>
    </Link>
  )
}

export default RowProductV2
